export default __webpack_public_path__ + "static/media/fortune DM.1a363de8.svg";